import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
@Service()
export default class LoginUserNameService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    private encodeBase64(plain: string): string {
        try {
            return btoa(unescape(encodeURIComponent(plain)));
        } catch {
            return btoa(plain);
        }
    }

    public async login(userName: string, password: string) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/login';
            const result = await this.axiosService.axiosInstance.post(url, {
                userName: this.encodeBase64(userName),
                password: this.encodeBase64(password),
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }
}
